export enum Permission {
  ADMIN = 1,
  SALES = 2,
  USER = 3
}
